// removed by extract-text-webpack-plugin
module.exports = {"contactsScrollButton":"pZ3dWY46QVK0mZUDDTEu_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/ContactsScrollButton/ContactsScrollButton.scss
// module id = 1723
// module chunks = 0